export enum DropdownAnimation {
  Expanding,
  Fade,
}

export interface DropdownController {
  open(animation: DropdownAnimation): void;
  close(): void;
}
